/**
 * PROSHOP — Page « Mes favoris ».
 *
 * Rend les produits de la wishlist (localStorage, cf. ps_wishlist.js) via l'API Store
 * WooCommerce (publique). MVP sans backend : la persistance reste côté client.
 */
const STORAGE_KEY = 'ps_wishlist';

const read = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
        return [];
    }
};

const write = (ids) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
        /* stockage indisponible */
    }
};

const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

document.addEventListener('DOMContentLoaded', () => {
    const app = document.getElementById('pdw-wishlist-app');
    if (!app) {
        return;
    }
    const empty   = document.querySelector('.pdw-wishlist-empty');
    const restUrl = app.dataset.rest;

    const showEmpty = () => { if ( empty ) { empty.hidden = false; } };
    const hideEmpty = () => { if ( empty ) { empty.hidden = true; } };

    const buildCard = (p) => {
        const el  = document.createElement('div');
        el.className = 'pdw-wishlist-item pdw-product-card';
        const img = (p.images && p.images[0]) ? p.images[0].src : '';
        el.innerHTML = `
            <button type="button" class="pdw-wishlist-remove" data-id="${esc(p.id)}" aria-label="Retirer des favoris">&times;</button>
            <a class="pdw-wishlist-item-media pdw-product-card-media" href="${esc(p.permalink)}">
                ${img ? `<img src="${esc(img)}" alt="${esc(p.name)}" loading="lazy">` : ''}
            </a>
            <div class="pdw-product-card-body">
                <a class="pdw-wishlist-item-title pdw-product-card-title-link" href="${esc(p.permalink)}">
                    <span class="pdw-product-card-title">${esc(p.name)}</span>
                </a>
                <div class="pdw-product-card-price pdw-wishlist-item-price">${p.price_html || ''}</div>
            </div>`;
        el.querySelector('.pdw-wishlist-remove').addEventListener('click', () => {
            write(read().filter((x) => String(x) !== String(p.id)));
            document.dispatchEvent(new Event('pdw:wishlist-changed'));
            render();
        });
        return el;
    };

    const render = async () => {
        const ids = read();
        app.innerHTML = '';

        if (!ids.length) {
            showEmpty();
            return;
        }
        hideEmpty();

        let products = [];
        try {
            const url = `${restUrl}?include=${ids.map(encodeURIComponent).join(',')}&per_page=100`;
            const res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (res.ok) {
                products = await res.json();
            }
        } catch (e) {
            /* réseau indisponible */
        }

        // Conserve l'ordre de la wishlist + ignore les produits supprimés/introuvables.
        const byId = {};
        products.forEach((p) => { byId[p.id] = p; });
        const ordered = ids.map((id) => byId[id]).filter(Boolean);

        if (!ordered.length) {
            showEmpty();
            return;
        }

        ordered.forEach((p) => app.appendChild(buildCard(p)));
    };

    render();
});
